import { ScaleFormatter } from "@/v2/components/formatters/ScaleFormatter";

export function getAvgSentimentScale(value: number) {
  if (value === 0) {
    return "neutral";
  }

  return value > 0 ? "positive" : "negative";
}

export function AvgSentimentFormatter({ value }: { value: number }) {
  return <ScaleFormatter value={value * 100} getScale={getAvgSentimentScale} />;
}
